module.exports = __webpack_public_path__ + "static/media/sakshi_pawar.a547aae5.jpg";